import {
  Box,
  Card,
  CardHeader,
  Container,
  makeStyles,
  useMediaQuery,
  useTheme,
  LinearProgress,
  Avatar,
  CardContent,
  Divider,
  Typography,
  Link,
  Button
} from "@material-ui/core";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { fade, slideRight, slideUp } from "../../util/transitions";

import Lottie from "react-lottie-player";
import animationData from "./mail.json";
import failAnimationData from "./mailfail.json";

import clsx from "clsx";
import { StringParam, useQueryParam } from "use-query-params";
import { processHealthPass } from "util/ProcessHealthPass";
import { isEmpty } from "lodash";
import { FormBuilder } from "@zennya/web-component-library/src/components/FormBuilder";
import { useHistory, useLocation } from "react-router-dom";
import qs from 'query-string';

const useStyles = makeStyles((theme) => ({
  lottie: {
    height: 250,
  },
  lottieWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  nameHeader: {
    fontWeight: "700",
    paddingBottom: theme.spacing(3)
  },
  rootContainer: {
    height: (props) => {
      console.log("📢[index.js:48]:", props);
      return `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`;
    },
    overflowY: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  container: {
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
  },
  logo: {
    height: "50px",
  },
  getStarted: {
    minWidth: 300,
    marginBottom: theme.spacing(3)
  },
  clicklink: {
    paddingTop: theme.spacing(2)
  }
}));

const Prelanding = ({ completedOnboarding, healthPass, ...props }) => {
  const classes = useStyles(props);
  const theme = useTheme();
  const history = useHistory()
  const location = useLocation()

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });
  const [startLottieAnim, setStartLottieAnim] = useState(false);

  const onClickGetStarted = () => {
    history.push({
      pathname: "/onboarding/medical",
      search: location.search,
    });
  }

  const onClickHealthPass = () => {
    history.push({
      pathname: "/onboarding/healthpass",
      search: qs.stringify(completedOnboarding),
    });
  }
  return (
    <motion.div
      {...slideUp}
      onAnimationComplete={(def) => setStartLottieAnim(true)}
    >
      <Container
        fixed
        maxWidth="md"
        className={clsx(classes.cardInset, classes.rootContainer)}
      >
        <Box className={clsx(classes.headerContainer, classes.container)}>
          <Card>
            <CardHeader
              avatar={
                <img
                  className={classes.logo}
                  alt="Apple"
                  src={healthPass.logo}
                />
              }
            />
            <Divider variant="middle"/>
            <CardContent>
              <Typography className={classes.nameHeader} variant="h4">Hi {healthPass?.medicalId?.firstName}!</Typography>
              <Typography variant="h5">{healthPass.company} has invited you to register to Corp Health via the Zennya App.</Typography>
              <Typography className={classes.clicklink} variant="body2">Click on the button below to get started</Typography>
              <div className={classes.lottieWrapper}>
                <Lottie
                  play={startLottieAnim}
                  loop={0}
                  segments={[0, 60]}
                  animationData={animationData}
                  className={classes.lottie}
                />
              </div>
              </CardContent>
              <CardContent>
                {!!completedOnboarding ? (
                  <>
                  <Typography variant="body2">Your account is already linked</Typography>
                  <Button className={classes.getStarted} onClick={()=> {onClickHealthPass()}} variant="contained" color="primary">Get Health Pass</Button>
                  </>
                ) : (
                  <Button className={classes.getStarted} onClick={()=> {onClickGetStarted()}} variant="contained" color="primary">Get Started</Button>
                )}
                <Typography className={classes.nameHeader} variant="h5">The zennya health team</Typography>
              </CardContent>
          </Card>
        </Box>
      </Container>
    </motion.div>
  );
};

const ErrorLanding = ({message, ...props}) => {
  const [startLottieAnim, setStartLottieAnim] = useState(false);
  const classes = useStyles(props);
  return (
    <motion.div
      {...fade}
      onAnimationComplete={(def) => setStartLottieAnim(true)}
    >
      <Container
        fixed
        maxWidth="md"
        className={clsx(classes.cardInset, classes.rootContainer)}
      >
        <Box className={clsx(classes.headerContainer, classes.container)}>
          <Card>
            <CardContent>
              <Typography className={classes.nameHeader} variant="h4">OOPS</Typography>
              <Typography variant="h5">{message}</Typography>
              <div className={classes.lottieWrapper}>
                <Lottie
                  play={startLottieAnim}
                  loop={0}
                  segments={[0, 60]}
                  animationData={failAnimationData}
                  className={classes.lottie}
                />
              </div>
              </CardContent>
          </Card>
        </Box>
      </Container>
    </motion.div>
  );
}

export default function PrelandingLoader() {
  const [loading, setLoading] = useState(true);
  const [healthPass, setHealthPass] = useState();
  const [cOnboarding, setCompletedOnboarding] = useState();
  const [hashId, setHashId] = useQueryParam("code", StringParam);
  const [parentOnboarded, setParentOnboarded] = useState(false);
  const [primary, setPrimary] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });

  useEffect(() => {
    async function fetchHealthPass() {
      if(hashId) {
        try {
          const {primary_employee, completedOnboarding, healthPass, medicalId } = await processHealthPass(hashId);
          setPrimary(primary_employee);
          if(!primary_employee) {
            setParentOnboarded(true)
          }
          if (primary_employee?.is_linked) {
            setParentOnboarded(true)
          }
          setHealthPass({ ...healthPass, medicalId });
          setCompletedOnboarding(completedOnboarding);
        } catch (e) {

        }
      }
      setLoading(false);
    }
    fetchHealthPass();
  }, [hashId]);

  if (loading) {
    return <LinearProgress />;
  }

  // if (!parentOnboarded) {
  //   return <ErrorLanding message={<>Primary account <b>{primary?.first_name} {primary?.last_name}</b> with company ID <b>{primary?.company_id}</b> needs to be onboarded first. <br/><br/> Contact primary employee / HR Officer to continue onboarding</>}/>
  // }

  if (hashId && healthPass) {
    return <Prelanding healthPass={healthPass} completedOnboarding={cOnboarding}  />;
  }
  

  return <ErrorLanding message='The invite code is missing or incorrect or has expired'/>
}
